import _classCallCheck from "/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/ubuntu/actions-runner/_work/my.phone.com/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import { NonInviteServerTransaction } from "../transactions";
import { UserAgentServer } from "./user-agent-server";
/**
 * PRACK UAS.
 * @public
 */
export var PrackUserAgentServer = /*#__PURE__*/function (_UserAgentServer) {
  _inherits(PrackUserAgentServer, _UserAgentServer);
  var _super = _createSuper(PrackUserAgentServer);
  function PrackUserAgentServer(dialog, message, delegate) {
    var _this;
    _classCallCheck(this, PrackUserAgentServer);
    _this = _super.call(this, NonInviteServerTransaction, dialog.userAgentCore, message, delegate);
    // Update dialog signaling state with offer/answer in body
    dialog.signalingStateTransition(message);
    _this.dialog = dialog;
    return _this;
  }
  /**
   * Update the dialog signaling state on a 2xx response.
   * @param options - Options bucket.
   */
  _createClass(PrackUserAgentServer, [{
    key: "accept",
    value: function accept() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        statusCode: 200
      };
      if (options.body) {
        // Update dialog signaling state with offer/answer in body
        this.dialog.signalingStateTransition(options.body);
      }
      return _get(_getPrototypeOf(PrackUserAgentServer.prototype), "accept", this).call(this, options);
    }
  }]);
  return PrackUserAgentServer;
}(UserAgentServer);